import { useEffect, useState } from "react"
import { getPaymentResult, GetPaymentResultResponse, PayementStatus } from "../../../services/ntuc/paymentService/payment"
import { searchParams } from '../../../helpers/search-params'
import { getPayment, OrderResponseWithOrderStatus, OrderStatus, PaymentResponse } from "../../../services/ntuc/memberService/payment"
import MembershipPaymentSuccess from "../../../components/Acknowledgement/MembershipPayment/PaymentSuccess/MembershipPaymentSuccess"
import MembershipPaymentPending from "../../../components/Acknowledgement/MembershipPayment/PaymentPending/MembershipPaymentPending"
import MembershipPaymentFailure from "../../../components/Acknowledgement/MembershipPayment/PaymentFailure/MembershipPaymentFailure"
import { ArrearsRouteProps } from "../ArrearsPaymentFlow/ArrearsPaymentFlow"
import { isNotEmpty } from "../../../helpers/StringHelpers"
import { DeviceType } from "../../../services/ntuc/memberService/oaMembership"
import { trackSignUpStep } from "../../../helpers/gtm"
interface MembershipPaymentAcknowledgementPageProps extends ArrearsRouteProps {
    orderId?: string
    order?: OrderResponseWithOrderStatus
}

const MembershipPaymentAcknowledgementPage = (props: ArrearsRouteProps) => {
    const { onNavigateTo } = props

    const [paymentResult, setPaymentResult] = useState<GetPaymentResultResponse>({
        status: PayementStatus.PENDING,
        clientOrderId: ``,
    })

    const [orderDetails, setOderDetails] = useState<OrderResponseWithOrderStatus | undefined>(undefined)

    const transformToOrderRequest = (content: PaymentResponse): OrderResponseWithOrderStatus => {
        return {
            feeType: parseInt(content.membershipPayment.feeType),
            endDate: content.membershipPayment.endDate,
            startDate: content.membershipPayment.startDate,
            serviceType: content.payment.serviceType,
            noOfMonths: content.membershipPayment.noOfMonths,
            amount: content.payment.orderAmount,
            isOneTimePayment: content.payment.isOneTimePayment,
            isRecurringPayment: content.payment.isRecurringPayment,
            membershipId: parseInt(content.membershipPayment.membershipId),
            deviceType: DeviceType.WEB,
            orderStatus: content.payment.orderStatus,
            renewalCampaignCode: content.renewalCampaignCode,
        }
    }

    const data = searchParams.Data
    const iv = searchParams.IV
    const tag = searchParams.tag || searchParams.Tag

    useEffect(() => {
        if (data && iv && tag) {
            getPaymentResult(data, iv, tag)
                .then(response => response.data.content)
                .then(setPaymentResult)
                .catch(error => {
                    console.error(error.message)
                })
        }
    }, [data, iv, tag])

    useEffect(() => {
        if (isNotEmpty(paymentResult.clientOrderId)) {
            getPayment(paymentResult.clientOrderId)
                .then(response => {
                    console.log(response.data.content)
                    const statusPayment = response.data.content.payment.orderStatus
                    trackSignUpStep(`Payment_${statusPayment}`)
                    return response
                })
                .then(response => response.data.content)
                .then(transformToOrderRequest)
                .then(setOderDetails)
                .catch(error => {
                    console.error(error.message)
                })
        }
    }, [paymentResult])

    switch (orderDetails?.orderStatus) {
        case OrderStatus.SEMI_SUCCESS_RECURRING:
        case OrderStatus.SEMI_SUCCESS_ONE_TIME:
        case OrderStatus.SUCCESS:
            return <MembershipPaymentSuccess orderId={paymentResult.clientOrderId} order={orderDetails} onNavigateTo={onNavigateTo} />
        case OrderStatus.FAILED:
        case OrderStatus.CANCELLED:
            return <MembershipPaymentFailure order={orderDetails} orderId={paymentResult.clientOrderId} onNavigateTo={onNavigateTo} />
        default:
            return <MembershipPaymentPending orderId={paymentResult.clientOrderId} onNavigateTo={onNavigateTo} />
    }
}

export default MembershipPaymentAcknowledgementPage
export type { MembershipPaymentAcknowledgementPageProps }